// 0017: persist the agent/admin on-behalf selected customer across refreshes, mirroring the cart
// persistence pattern (persistCartStateMiddleware). The selected customer is the SAME single source
// of truth used by the cart banner and the order's customerId (state.agentOrderReducer). Without
// this, a refresh silently drops who the agent/admin is ordering for. The key is removed on logout
// (see account.actions.js) so a selection never leaks across sessions/roles.
export const AGENT_ORDER_STORAGE_KEY = "agentOrderState";

export const persistAgentOrderStateMiddleware = (store) => (next) => (action) => {
  const result = next(action); // Let the action proceed
  const state = store.getState(); // Get the updated state
  try {
    const serializedState = JSON.stringify(state.agentOrderReducer);
    localStorage.setItem(AGENT_ORDER_STORAGE_KEY, serializedState);
  } catch (err) {
    console.error("Failed to save agent-order state to localStorage:", err);
  }
  return result;
};
